<template>
    <label :for="id" :class="blueClass != undefined ? 'blueBg' : ''">
        <span>{{ label }}</span>
        <input v-if="type != 'select'" :type="type" :id="id" :value="modelRef" @input="inputFunc"
            :maxlength="max != undefined ? max : 2000" :min="min != undefined ? 0 : false"
            :disabled="editable != undefined && editable == false" />
        <select v-else :id="id" :value="modelRef" @change="inputFunc" :disabled="editable != undefined && editable == false">
            <option disabled selected value class="defaultopt">Selecione uma opção</option>
            <option v-for="(opt, idx) in optList" :key="idx" :value="useIdx == true ? idx : opt[`${optValue}`]">{{
                opt[`${optDisplay}`][0].toUpperCase() + opt[`${optDisplay}`].slice(1) }}
            </option>
        </select>
    </label>
</template>

<script>
export default {
    name: "CustominputRta",
    props: ["id", "type", "label", "modelRef", "editable", "min", "max", "inputFunc", "blueClass", 'optList', 'optValue', 'optDisplay', 'useIdx']
}
</script>

<style scoped>
label {
    width: 100%;
    position: relative;
}

label span {
    position: absolute;
    top: -.8rem;
    left: 0.4rem;
    background-color: white;
    font-size: 0.8rem;
    color: #FF5F00;
    padding-left: 0.3rem;
    padding-right: 0.5rem;
    font-weight: 500;
}

label input,
label select {
    width: 100%;
    height: 100%;
    padding: 0.4rem 0.5rem;
    border: 1px solid #C7C7C7 !important;
    border-radius: 0.2rem;
}

.blueBg span {
    color: #008787 !important;
}

.defaultopt{
    color: #999999;
}
</style>